<script lang="ts">
	import type { AggregatedPunchStats } from '../types';

	export let stats: AggregatedPunchStats;
	export let corner: 'red' | 'blue';

	const statGroups = {
		Distance: stats.distance,
		Clinch: stats.clinch,
		TOTAL: stats.total
	};
</script>

<div class="column" class:spacer={corner === 'blue'}>
	<h4 class="{corner} text-center py-2 mb-0">Knockdowns</h4>
	<table class="py-4">
		<thead>
			<tr>
				<td class="pt-3" />
			</tr>
		</thead>
		<tbody>
			{#each Object.entries(statGroups) as [title, stat]}
				<tr class="group-header">
					<td colspan="2"><strong>{title}</strong></td>
					<td>{stat.total}</td>
				</tr>

				<tr>
					<td />
					<td>Head</td>
					<td>{stat.head}</td>
				</tr>

				<tr>
					<td class="pb-3" />
					<td class="pb-3">Body</td>
					<td class="pb-3">{stat.body}</td>
				</tr>
			{/each}
		</tbody>
	</table>
</div>

<style>
	.column {
		width: 37%;
	}

	table {
		background-color: white;
		width: 100%;
	}

	td {
		padding-right: 10px;
		padding-left: 10px;
	}

	.spacer {
		margin-right: 5%;
	}
	.blue {
		color: white;
		background-color: blue;
	}

	.red {
		background-color: red;
		color: white;
	}

	.group-header {
		background-color: lightgray;
	}

	td {
		padding-right: 10px;
		padding-left: 10px;
	}

	@media (max-width: 576px) {
		.spacer {
			margin-right: 10px;
		}
		.column,
		.column {
			width: 50%;
		}

		td {
			padding-right: 0;
			padding-left: 0;
			font-size: 14px;
		}
	}
</style>
